import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type Quote } from '../prospects/types'

export function useGetQuote ({ prospectId, quoteId, refetchUntilProcessed }: {
  prospectId: string,
  quoteId: string,
  refetchUntilProcessed?: boolean
}) {
  return useQuery<Quote, GrapeAPIErrorType>({
    queryKey: ['prospect', prospectId, 'quote', quoteId],
    queryFn: async () => {
      const response = await fetchWithHeaders(`/api/web/quoting/prospects/${prospectId}/quotes/${quoteId}`)
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    retry: false,
    refetchInterval: (query) => {
      if (!refetchUntilProcessed || query.state.error || ['processed', 'failed'].includes(query.state.data?.status ?? '')) {
        return false
      }
      return 1_000
    },
  })
}
